import { render, staticRenderFns } from "./QuickItemDetail.vue?vue&type=template&id=381113b8&scoped=true"
import script from "./QuickItemDetail.vue?vue&type=script&lang=js"
export * from "./QuickItemDetail.vue?vue&type=script&lang=js"
import style0 from "./QuickItemDetail.vue?vue&type=style&index=0&id=381113b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381113b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381113b8')) {
      api.createRecord('381113b8', component.options)
    } else {
      api.reload('381113b8', component.options)
    }
    module.hot.accept("./QuickItemDetail.vue?vue&type=template&id=381113b8&scoped=true", function () {
      api.rerender('381113b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickitem/QuickItemDetail.vue"
export default component.exports